module.exports = __webpack_public_path__ + "img/geocircle.462359b8.png";